module.exports = __webpack_public_path__ + "9c47d6bdfbb5f7b3bae04669fe5e631d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/facilities-map.svg
// module id = 600
// module chunks = 0